import { useState, useEffect } from "react";
import SidePanel from "../../components/SidePanel";
// import draft_img from "../../assets/icons/Draft_IMG.svg";
import Spinner from "../../components/Spinner";
import { Link, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import GenerateCardPopup from "../../components/GenerateCardPopup";
import { toast } from "react-toastify";

const EventsDetails = () => {
  const token = localStorage.getItem("token");
  const customerID = localStorage.getItem("ID");
  const [loader, setLoader] = useState(true);
  const [drafts, setDrafts] = useState([]);
  console.log('drafts: ', drafts);
  const [suggestions, setSuggestions] = useState([]);
  const [title, setTitle] = useState("");
  const [selectedOccasion, setSelectedOccasion] = useState("");
  const [forWhom, setForWhom] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [filteredCards, setFilteredCards] = useState([]);
  const [me, setMe] = useState("");
  const [occasions, setOccasions] = useState([]);
  const [orderModal, setOrderModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState("");
  const [selectedCardID, setSelectedCardID] = useState("");
  const toggleOrderModal = () => {
    setOrderModal(!orderModal);
  };

  const [searchParams, setSearchParams] = useSearchParams();
  const recipientId = searchParams.get("_id");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const titleFromUrl = urlParams.get("title");
    if (titleFromUrl) {
      setTitle(titleFromUrl);
      const name = titleFromUrl.split("'s")[0];
      const occasion = titleFromUrl.split("'s").slice(1).join("'s").trim();
      setSelectedOccasion(occasion); // Set occasion early
      setRecipientName(name);
      // getCustomerRecipientDetails(name, occasion); // Fetch gender based on recipient name and occasion
    }
  }, [customerID, token]);

  useEffect(() => {
    if (title && token) {
      fetchEventIdByName(selectedOccasion).then((eventId) => {
        if (eventId) {
          fetchFilteredDrafts(eventId, recipientName);
        } else {
          setLoader(false); // Handle case where no event ID is found
        }
      });
    }
  }, [title, token, selectedOccasion, recipientName]);

  const generateCard = async (card) => {
    const name = card?.receiptsId?.fullName;
    const recipientID = card?.receiptsId?._id;
    const relationship = card?.receiptsId?.relationShip;
    const eventId = card?.eventId;
    const birthday =
      card?.receiptsId?.dob && format(card?.receiptsId?.dob, "yyyy-MM-dd");
    const gender = card?.receiptsId?.gender;
    const character_traits = card?.receiptsId?.characterTraits;
    const messageTheme = card?.messageTheme;
    const selectedCard = card?.cardId?.thumbnail;
    const selectedCardID = card?.cardId?._id;
    const occasion = occasions.find((o) => o?._id === card?.eventId)?.name;
    const greetings = card?.textTo;
    const text = card?.textCard;
    const signoff = card?.textFrom;
    const EventOfRecipientId = card?._id;
    const eventStatus = card?.status;
    const eventDate = card?.eventDate;
    console.log({ card });

    let missingData = [];

    if (!name) missingData.push("name");
    if (!recipientID) missingData.push("recipientID");
    if (!relationship) missingData.push("relationship");
    if (!eventId) missingData.push("eventId");
    if (!birthday) missingData.push("birthday");
    if (!gender) missingData.push("gender");
    if (!character_traits) missingData.push("character_traits");
    if (!messageTheme) missingData.push("messageTheme");
    if (!selectedCard) missingData.push("selectedCard");
    if (!selectedCardID) missingData.push("selectedCardID");
    if (!me) missingData.push("me");
    if (!occasion) missingData.push("occasion");
    if (!greetings) missingData.push("greetings");
    if (!text) missingData.push("text");
    if (!signoff) missingData.push("signoff");
    if (!EventOfRecipientId) missingData.push("EventOfRecipientId");

    if (missingData.length > 0) {
      toast.error("Missing data");
      console.log("Missing data: " + missingData.join(", "));
    } else {
      const params = new URLSearchParams({
        name: name,
        recipientID: recipientID,
        relationship: relationship,
        occasion: occasion,
        eventId: eventId,
        birthday: birthday,
        gender: gender,
        character_traits: character_traits,
        messageTheme: messageTheme,
        me: me,
        thumbnail: selectedCard,
        selectedCardID: selectedCardID,
        greetings: greetings,
        text: text,
        signoff: signoff,
        eventOfRecipientId: EventOfRecipientId,
        fromNavigatedPageName:
          eventStatus === "draft" ? "Draft" : "SendToPrints",
        page: "3",
        eventDate: eventDate,
      });

      window.location.href = `/dashboard/card_generation/pick?${params.toString()}`;
    }
  };

  // Fetch Event ID by Event Name
  const fetchEventIdByName = async (eventName) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
      }
    );
    const { data } = await response.json();
    const event = data.find(
      (e) => e.name.toLowerCase() === eventName.toLowerCase()
    );
    return event?._id; // Return the ID of the event
  };

  const fetchFilteredDrafts = async (eventId, name) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/eventOfRecipient/get-customer-cards?receiptsId=${recipientId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
      }
    );
    const { data } = await response.json();
    // Assuming filtering on client-side; adapt as needed
    const filteredDrafts = data?.filter((draft) => draft?.eventId === eventId);
    setDrafts(filteredDrafts);
    setLoader(false); // Turn off the loading spinner
  };

  // Extract and set the title from URL
  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const titleFromUrl = urlParams.get("title");
  //   if (titleFromUrl) {
  //     setTitle(titleFromUrl);
  //   }
  // }, []);

  useEffect(() => {
    const getEvents = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customer/get-customer-recipients/` +
            customerID,
          {
            method: "GET",
            headers: {
              "content-type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        const name = title?.split("'s")[0];
        const occasion = title.split("'s").slice(1).join("'s").trim();

        const allRecipients = data.data;
        const gender = allRecipients?.filter(
          (recipient) => recipient.fullName === name
        )[0]?.gender;
        if (occasion) {
          setSelectedOccasion(occasion);
        }
        if (gender) {
          setForWhom(gender);
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (token && customerID && title) {
      getEvents();
    }
  }, [customerID, token, title]);

  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const titleFromUrl = urlParams.get("title");
  //   if (titleFromUrl) {
  //     setTitle(titleFromUrl);
  //   }
  // }, []);

  useEffect(() => {
    // Filtering cards based on occasion and gender
    let updatedFilteredCards = suggestions;
    if (selectedOccasion) {
      updatedFilteredCards = updatedFilteredCards.filter((card) =>
        card.categories.some(
          (category) =>
            category.name.toLowerCase() === selectedOccasion.toLowerCase()
        )
      );
    }
    if (forWhom) {
      updatedFilteredCards = updatedFilteredCards.filter((card) =>
        card.tags.some(
          (tag) => tag.name.toLowerCase() === forWhom.toLowerCase()
        )
      );
    }
    setFilteredCards(updatedFilteredCards);
  }, [selectedOccasion, forWhom, suggestions]);

  // useEffect(() => {
  //   setLoader(true);
  //   const fetchCards = async () => {
  //     const res = await fetch(
  //       `${process.env.REACT_APP_API_URL}/api/card/get-cards`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "x-sh-auth": token,
  //         },
  //       }
  //     );
  //     const data = await res.json();
  //     setTimeout(() => {
  //       setLoader(false);
  //     }, 2000);
  //     setSuggestions(data.data);
  //   };
  //   if (token) {
  //     fetchCards();
  //   }
  // }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchMe = async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
      });
      const data = await res.json();
      if (res.status === 200) {
        setMe(data.detail.fullName);
      }
    };
    if (token) {
      fetchMe();
    }
  }, []);

  useEffect(() => {
    const fetchOccasion = async () => {
      const token = localStorage?.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const res = await response.json();
      const status = res.code;
      if (status === 200) {
        setOccasions(res.data);
      }
    };
    fetchOccasion();
  }, []);

  return (
    <section className="flex">
      {orderModal && (
        <GenerateCardPopup
          toggleOrderModal={toggleOrderModal}
          selectedCard={selectedCard}
          selectedCardID={selectedCardID}
          eventData={drafts[0]}
        />
      )}
      <SidePanel />
      <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
        <h3 className="mb-5">
          <Link to="/dashboard/calender" className="hover:underline">
            Calendar
          </Link>
          {" > "} <span className="text-primary">Event Details</span>
        </h3>
        <h1 className="text-4xl text-gray-500 font-bold sm:text-left text-center mb-5">
          {title && title}
        </h1>
        {loader ? (
          <div className="h-full flex items-center justify-center">
            <Spinner props="Loading..." size={"100"} />
          </div>
        ) : (
          <>
            <div className="w-full">
              <h3 className="text-3xl font-semibold mt-10">Card</h3>
              {drafts?.length === 0 ? (
                <div className="flex items-center justify-center mt-5">
                  <p className="text-xl mt-10 text-gray-500 font-semibold">
                    You Have No Saved Drafts
                  </p>
                </div>
              ) : (
                <div className="xl:grid grid-cols-5 flex flex-wrap items-center justify-center gap-3 mt-3 mb-5">
                  {drafts?.map((card, index) => (
                    <div className="relative w-fit" key={index}>
                      <div>
                        <div>
                          <img
                            src={card?.cardId?.thumbnail}
                            alt="placeholder_img"
                            className="relative rounded-md w-72 inset-[-1] shadow-lg"
                          />
                          <button
                            onClick={() => generateCard(card)}
                            className="mt-3 w-full py-2 rounded-md border-2 border-primary text-primary hover:bg-primary-light"
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="w-full relative">
              <h3 className="text-3xl font-semibold mt-10">Suggestions</h3>
              {filteredCards.length === 0 ? (
                <div className="flex items-center justify-center flex-col mt-5">
                  <p className="text-[4.6rem] text-center sticky top-[15%] mt-24 font-bold">
                    Coming Soon...
                  </p>
                  {/* <p className="text-xl mt-10 text-gray-500 font-semibold">
                    No Suggestions for this Occasion
                  </p> */}
                </div>
              ) : (
                <>
                  {/* <div className="xl:grid grid-cols-5 flex flex-wrap items-center justify-center gap-3 mt-3 mb-5">
                    {filteredCards.map((card, index) => {
                      const filterSelectedCard = drafts.filter(
                        (item) => item.cardId._id === card._id
                      );
                      console.log({ card, filterSelectedCard, drafts });
                      return (
                        <div className="relative w-fit" key={index}>
                          <div>
                            <div>
                              <img
                                src={card.thumbnail}
                                alt="placeholder_img"
                                className="relative rounded-md w-72 inset-[-1] shadow-lg"
                              />
                              <button
                                onClick={() => {
                                  setSelectedCard(card.thumbnail);
                                  setSelectedCardID(card._id);
                                  toggleOrderModal();
                                }}
                                // onClick={     onClick={toggleOrderModal}}
                                className="mt-3 w-full py-2 rounded-md border-2 border-primary text-primary hover:bg-primary-light"
                              >
                                View
                              </button> 
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div> */}
                  <div
                    style={{ background: "rgb(148 163 184 / 28%)" }}
                    className="font-semibold absolute  top-0 left-0 right-0 bottom-0"
                  >
                    <p className="text-[4.6rem] text-center sticky top-[20%] mt-[11.5rem]">
                      Coming Soon...
                    </p>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default EventsDetails;
